import * as z from 'zod';

import { Button } from '@/components/Elements';
import { Form, InputField } from '@/components/Form';

import { useCreatePasswordlessLogin } from '../api/passwordlessLogin';

const schema = z.object({
  email: z.string().min(1, 'Required').email(),
});

type LoginValues = {
  email: string;
};

export const PasswordlessLoginForm = () => {
  const createPasswordlessLogin = useCreatePasswordlessLogin();

  return (
    <div>
      <Form<LoginValues, typeof schema>
        onSubmit={async (values) => {
          await createPasswordlessLogin.mutateAsync(values);
        }}
        schema={schema}
      >
        {({ register, formState }) => (
          <>
            <InputField
              type="email"
              label="Email Address"
              error={formState.errors['email']}
              registration={register('email')}
            />
            <div>
              <Button
                isLoading={createPasswordlessLogin.isLoading}
                disabled={createPasswordlessLogin.isLoading}
                type="submit"
                className="w-full"
              >
                Send
              </Button>
            </div>
          </>
        )}
      </Form>
    </div>
  );
};
